import {styledByTheme} from "../../../../../../themes/architecture/styled-by-theme";
import {SearchInputAreaDefaultBox} from "./search-input-area.default.box";
import {SearchInputAreaCasino777Box} from "./search-input-area.casino777.box";
import {SearchInputArenaHarrahsBox} from "./search-input-area.harrahs.box";
import {SearchInputAreaCasino888WsopBox} from "./search-input-area.casino888Wsop.box";
import {SearchInputArenaSIBox} from "./search-input-arena.si.box";
import {SearchInputAreaMrGreenBox} from "./search-input-area.mrgreen.box";
import { SearchInputAreaMrGreenCisBox } from "./search-input-area.mrgreenCis.box";


export const SearchInputAreaBox = styledByTheme(SearchInputAreaDefaultBox)
    .forCasino888(SearchInputAreaCasino888WsopBox)
    .forWsop(SearchInputAreaCasino888WsopBox)
    .forCasino777(SearchInputAreaCasino777Box)
    .forHarrahs(SearchInputArenaHarrahsBox)
    .forSI(SearchInputArenaSIBox)
    .forSICis(SearchInputArenaSIBox)
    .forMrGreen(SearchInputAreaMrGreenBox)
    .forMrGreenCis(SearchInputAreaMrGreenCisBox)
    .apply();
